export const appsGetDefaultCustomPagesAppGroupId = "/apps/get_default_custom_pages/:app_group_id";
